import {
  EARLY_ACCESS_TO_NEW_IN,
  LOYALTY_NEW_IN_EXPERIMENT_KEY
} from "../../state/modules/category/constants";
import { getLoyaltyBenefitType } from "../../state/modules/category/selectors";
import sdkProvider from "../sdkProvider";

const newInRedirect = async ({ state }) => {
  const loyaltyBenefitType = getLoyaltyBenefitType(state);

  if (loyaltyBenefitType !== EARLY_ACCESS_TO_NEW_IN) {
    return;
  }

  const loyaltyAvailable = await isLoyaltyAvailable();
  if (!loyaltyAvailable) {
    return;
  }

  const featuresSdk = await sdkProvider("features");
  await featuresSdk.onReady();

  const { isEnabled, getVariables } =
    featuresSdk.getFeature(LOYALTY_NEW_IN_EXPERIMENT_KEY, null, {
      app: "plp"
    }) || {};

  const isInExperiment = isEnabled() && getVariables()?.bucket === "v2";

  if (isInExperiment) {
    return;
  }

  const identitySdk = await sdkProvider("identity");
  const isAuthenticated = await identitySdk.customer.isAuthenticated();

  if (!isAuthenticated) {
    identitySdk.login();

    return true;
  }
};

const isLoyaltyAvailable = async () => {
  try {
    const loyaltySdk = await sdkProvider("loyalty");

    return await loyaltySdk.isLoyaltyAvailable();
  } catch (error) {
    return false;
  }
};

export default newInRedirect;
